<template>
    <div class="mt-2 flex items-center text-sm leading-5 text-gray-500">
        <svg
            fill="currentColor"
            viewBox="0 0 20 20"
            class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400"
        >
            <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"></path>
        </svg>
        <span class="truncate">

            <div class="text-sm leading-5 text-gray-500">
                <a :href="`tel:${mobile}`">
                    {{ mobile }}
                </a>
            </div>
        </span>
    </div>
</template>
<script>
export default {
    props: ["mobile"]
};
</script>
